<template>
    <div id="guitar-gallery-modal" class="category-body-shapes" style="display: none;" v-if="facetsList.length">
        <span v-if="name">{{ name }}</span>
        <transition name="slide-toggle">
            <div class="mobile-menu" v-if="visibleMenu">
                <div class="brand-list">
                    <a :href="facet.url" v-for="(facet, index) in facetsList" :key="index" class="category-brand__link" :class="{ 'category-brand__body-link' : name == 'Shop by body shape'}" v-show="visibleFacets(index)">
                        <img :src="normalizeShapename(facet.name)" :alt="facet.name" v-if="(name == 'Shop by body shape') && checkCat" class="cat-body-shape" @error="bodyShapeFallback"/>
                        <span class="body-name">
                            {{ facet.name }} <span v-if="facet.count">{{ facet.count }}</span>
                        </span>
                    </a>
                </div>
            </div>
        </transition>
        <button class="btn btn--toggle" v-if="this.facetsList.length > this.limit" @click.prevent="toggleVisible">{{ showAllText }}</button>
    </div>
</template>

<script>
    export default {
        props: {
            facetsJson: {
                default: '',
                type: String,
            },
            mainCat: {
                default: '',
                type: String,
            },
            facets: false,
            limit: {
                default: 14,
                type: Number,
            },
            name: {
                default: '',
                type: String,
            },
            attributeType: {
                default: 'Brands',
            },
            alphabeticalJson: {
                default: '',
                type: String,
            },
        },
        data() {
            return {
                showAll: false,
                active: false,
                isMobile: false,
                showMenu: false,
            };
        },
        computed: {
            facetsList() {
                let facets = this.facets;
                if (!facets || typeof facets !== 'object') {
                    try {
                        if(this.showAll && this.alphabeticalJson !== ''){
                            facets = JSON.parse(this.alphabeticalJson);
                        } else {
                            facets = JSON.parse(this.facetsJson);
                        }
                    } catch (e) {
                        facets = [];
                    }
                }
                return facets;
            },
            visibleMenu() {
                return !this.isMobile || this.showMenu;
            },
            showAllText() {
                return (this.showAll ? 'Show Fewer' : 'Show More');
            },
            showMenuText() {
                return (this.showMenu ? 'Hide': 'Show');
            },
            checkCat(){
                if(this.mainCat == "Electric Guitar"){
                    return true
                } else {
                    return false
                }
            }
        },
        created() {
            window.addEventListener('resize', this.resize);
            this.resize();
            this.facetLimit();
        },
        methods: {
            facetLimit() {
                this.limit = 14;
                if (window.innerWidth <= 1399) {
                    this.limit = 12;
                }
                if (window.innerWidth <=1250) {
                    this.limit = 10;
                }
                if (window.innerWidth <=1000) {
                    this.limit = 8;
                }
                if (window.innerWidth <=850) {
                    this.limit = 9;
                }
                if (window.innerWidth <= 750) {
                    this.limit = 8;
                }
                if (window.innerWidth <= 525) {
                    this.limit = 9;
                }
                if (window.innerWidth <= 525) {
                    this.limit = 6;
                }
            },
            visibleFacets(index) {
                return (this.showAll || index < this.limit || this.isMobile ? true : false);
            },
            toggleVisible() {
                this.showAll = !this.showAll;
            },
            toggleMenu() {
                this.showMenu = !this.showMenu;
            },
            resize() {
                this.facetLimit();
            },
            normalizeShapename(a){
                var b = a.toString().replace(' ', '-').toLowerCase()
                var c = "https://media.sweetwater.com/m/body-shapes/electric-guitars/";
                c += b;
                c += ".svg";
                return c;
            },
            bodyShapeFallback(event) {
                event.target.src = "https://media.sweetwater.com/m/body-shapes/fallback.svg"
            }
        },
    };
</script>

<style scoped>
.cat-body-shape {
    vertical-align: bottom;
    margin: 0 auto;
    height: 6.25rem;
    background: #f3f1ee;
    border-radius: 500px;
    padding: 12px;
    overflow: visible;
}

.cat-body-shape:hover {
    background: #d7efff;

}
.category-brand__body-link {
    display: grid;
    align-items: center;
    width: calc(100%/7);

}
@media screen and (max-width: 1399px) {
    .category-brand__body-link {
        width: calc(100%/6);
    }
}

@media screen and (max-width: 1250px) {
    .category-brand__body-link {
        width: calc(100%/5);
    }
}

@media screen and (max-width: 1000px) {
    .category-brand__body-link {
        width: calc(100%/4);
    }
}

@media screen and (max-width: 850px) {
    .category-brand__body-link {
        width: calc(100%/3);
    }
}

@media screen and (max-width: 750px) {
    .category-brand__body-link {
        width: calc(100%/4);
    }
}
@media screen and (max-width: 525px) {
    .category-brand__body-link {
        width: calc(100%/3);
    }
}

@media screen and (max-width: 425px) {
    .category-brand__body-link {
        width: calc(100%/2);
    }
}

.category-brand__link:hover {
  background: #ffffff;
}

.category-body-shapes {
    margin: 60px 0;
    text-align: center;
    width: 100%;
}

.brand-list{
    padding: 0;
}

.btn--toggle {
    margin: 0.5rem auto 0.25rem;
    padding: 0.6rem 1rem;
}

.body-name {
    padding: 0.75rem 0;
    color: black;
}
</style>